import React from 'react';
import useOrganizationUsers from '../../../../hooks/api/useOrganizationUsers';
import { AnimateLoadedContent } from '../../../v2BaseComponents/Loader';
import DetailsContent from './DetailsContent';

export type OrganizationUserDetailsOwnProps = {
    organizationUserId: string;
};

export type OrganizationUserDetailsProps = OrganizationUserDetailsOwnProps;

const OrganizationUserDetails: React.FC<OrganizationUserDetailsProps> = ({ organizationUserId }) => {
    const { isLoadingUser, user, isLoadingUserGroups, userGroups } = useOrganizationUsers({
        organizationUserId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingUser || isLoadingUserGroups || !user || !userGroups}>
            {() => <DetailsContent user={user!} userGroups={userGroups} />}
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationUserDetails);
